import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import BrownRiceProduct from 'models/BrownRiceProduct'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import {
  oatCookingTypeOptions,
  oatVarietyOptions,
  grainLengthOptions,
  packagingInitialState,
} from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { isNotAlpha, isNotNumericDecimal } from 'context/Utilities'

const BrownRicePackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  // eslint-disable-next-line no-unused-vars
  const [packaging, setPackaging] = useState(packagingInitialState)

  const { onChange, setSelect, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const {
        category,
        subCategory,
        GrainSize,
        CookingType,
        OatVariety,
        GrainLength,
        otherType,
      } = current
      setPackaging({
        category,
        subCategory,
        GrainSize,
        CookingType: {
          value: CookingType || '',
          label:
            CookingType.length > 0 ? CookingType : 'Brown Rice Cooking Type',
        },
        OatVariety: {
          value: OatVariety || '',
          label: OatVariety.length > 0 ? OatVariety : 'Brown Rice Variety',
        },
        GrainLength: {
          value: GrainLength || '',
          label: GrainLength.length > 0 ? GrainLength : 'Grain Length',
        },
        otherType,
      })
    } else if (!updating) {
      setCurrent(BrownRiceProduct)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  useEffect(() => {
    if (updating) {
      if (current?.OatVariety === 'Other') {
        methods.setValue('otherType', current.otherType)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updating])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Cooking Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={oatCookingTypeOptions}
          name="CookingType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Cooking Type'}
          onChange={([selected]) => {
            setSelect(selected, 'CookingType')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="CookingType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <p>
          <strong>Grain Length {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={grainLengthOptions}
          name="GrainLength"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Grain Length'}
          onChange={([selected]) => {
            setSelect(selected, 'GrainLength')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="GrainLength"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
      <Col xs={6}>
        <p>
          <strong>Variety {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={oatVarietyOptions}
          name="OatVariety"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Variety'}
          onChange={([selected]) => {
            setSelect(selected, 'OatVariety')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="OatVariety"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        {current?.OatVariety === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Type (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="otherType"
              placeholder={'Other Type'}
              control={methods.control}
              rules={{
                required: true,
                maxLength: {
                  value: 15,
                  message: '⚠ Other Type exceeds 15 characters.',
                },
              }}
              onKeyDown={e => {
                if (isNotAlpha(e.key) && e.key !== ' ') {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="otherType"
                message={'Other type is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            name="GrainSize"
            placeholder={'12 - 48 ounces'}
            control={methods.control}
            rules={{
              validate: GrainSize => GrainSize >= 12 && GrainSize <= 48,
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
            }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="GrainSize"
              message={'⚠ Size must be between 12 - 48 ounces.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

export default BrownRicePackage
